import { createSlice } from "@reduxjs/toolkit";
import { listFeedback, getFeedback, addFeedbackComment, cancelFeedback } from "./thunks";
import { logout, expiredLogout } from "../auth/thunks";

const initialState = {
  list: { issues: [], total: 0, start_at: 0, max_results: 20 },
  selected: null,
};

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    clearSelected: (state) => {
      state.selected = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listFeedback.fulfilled, (state, action) => {
        state.list = {
          issues: action.payload?.issues ?? [],
          total: action.payload?.total ?? 0,
          start_at: action.payload?.start_at ?? 0,
          max_results: action.payload?.max_results ?? 20,
        };
      })
      .addCase(getFeedback.fulfilled, (state, action) => {
        state.selected = action.payload;
      })
      .addCase(cancelFeedback.fulfilled, (state, action) => {
        const cancelledKey = action.payload?.issue_key;
        const newStatus = action.payload?.status;
        if (cancelledKey && state.selected && state.selected.issue_key === cancelledKey) {
          state.selected = { ...state.selected, status: newStatus, can_cancel: false };
        }
        if (cancelledKey) {
          state.list.issues = state.list.issues.map((i) =>
            i.issue_key === cancelledKey ? { ...i, status: newStatus } : i
          );
        }
      })
      .addCase(addFeedbackComment.fulfilled, (state, action) => {
        if (state.selected && action.payload?.comment_id) {
          const newComment = {
            id: action.payload.comment_id,
            body: action.payload.body,
            created: action.payload.created,
            author: "You",
          };
          state.selected = {
            ...state.selected,
            comments: [...(state.selected.comments || []), newComment],
          };
        }
      })
      .addCase(logout.fulfilled, () => initialState)
      .addCase(expiredLogout.fulfilled, () => initialState);
  },
});

export const { clearSelected } = feedbackSlice.actions;
export default feedbackSlice.reducer;
